import { ThunkAction, ThunkDispatch } from "redux-thunk";
import * as storeTypes from "../storeTypes";
import * as storeActions from "../storeActions";
import * as riskService from "../../services/riskService";
import { handleApiError } from "../storeEffects";
import { RiskAction, riskFailure, riskSuccess } from "./storeRisk";

//Effects
export type RiskThunkDispatch = ThunkDispatch<storeTypes.IApplicationState, null, RiskAction>

export const getRiskPage = (): ThunkAction<any, storeTypes.IApplicationState, any, any> => (dispatch, getState) => {
    dispatch(storeActions.fetchStart());
    return riskService.getRiskPage()
        .then(
            riskPage => {
                dispatch(riskSuccess(riskPage));
            },
            error => {
                handleApiError(error, dispatch);
                dispatch(riskFailure());
            })
        .finally(() =>
            dispatch(storeActions.fetchEnd())
        );
};
